<template>
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2391_837)">
            <g clip-path="url(#clip1_2391_837)">
                <path d="M5 9.72846L7.72639 12.3135L13 7.31348" stroke="white" stroke-width="1.2" stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M1.66127 6.12356C1.23589 7.10084 0.999999 8.17961 0.999998 9.31348C0.999998 13.7318 4.58172 17.3135 9 17.3135C13.4183 17.3135 17 13.7318 17 9.31348C17 4.8952 13.4183 1.31348 9 1.31348C7.34838 1.31348 5.81365 1.81398 4.53923 2.67159"
                    stroke="white" stroke-width="1.2" stroke-linecap="round" />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_2391_837">
                <rect width="18" height="18" fill="white" />
            </clipPath>
            <clipPath id="clip1_2391_837">
                <rect width="18" height="18" fill="white" transform="translate(0 0.313477)" />
            </clipPath>
        </defs>
    </svg>

</template>